import Sqids from "sqids";
import { useMemo } from "react";

const sqids = new Sqids({ minLength: 6 });

export function useSqids() {
  const encode = useMemo(() => {
    return (id: number): string => {
      return sqids.encode([id]);
    };
  }, []);

  const decode = useMemo(() => {
    return (slug: string): number | null => {
      const decoded = sqids.decode(slug);
      return decoded.length > 0 ? decoded[0] : null;
    };
  }, []);

  return { encode, decode };
}
